import { render, staticRenderFns } from "./modalCompraIngreso.vue?vue&type=template&id=d4e58908&scoped=true&"
import script from "./modalCompraIngreso.vue?vue&type=script&lang=js&"
export * from "./modalCompraIngreso.vue?vue&type=script&lang=js&"
import style0 from "./modalCompraIngreso.vue?vue&type=style&index=0&id=d4e58908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e58908",
  null
  
)

export default component.exports